program Uzysk2;

uses
  WEBLib.Forms,
  Uzysk in 'Uzysk.pas'{*.html};

{$R *.res}

begin
  Application.Initialize;
  Application.MainFormOnTaskbar := True;
  Application.CreateForm(TForm1, Form1);
  Application.Run;
end.
